
import { Vue, Component, Ref, Watch } from 'vue-property-decorator';
import SPUService from '@/services/spu.service';
import lazyInject from '@/di';
import UploadImageModal from './components/UploadImageModal.vue';
import ProductImageModal from './components/ProductImageModal.vue';
import moment from 'moment';

@Component({
  components: {
    UploadImageModal,
    ProductImageModal,
  },
})
export default class ProductImageManagement extends Vue {
  @lazyInject(SPUService)
  protected spuService!: SPUService;

  @Ref('uploadImageModal')
  uploadImageModal!: UploadImageModal;

  @Ref('productImageModal')
  productImageModal!: ProductImageModal;

  pagination = {
    total: 0,
    current: 1,
    pageSize: 10,
    onChange: this.onChangePage,
    showSizeChanger: true,
    pageSizeOptions: this.$store.state.pageSize.pageSize,
    onShowSizeChange: this.onShowSizeChange,
  };

  form: any = {
    photoTypeId: undefined,
    photoName: '',
    isDefault: undefined,
    status: undefined,
    endDate: '',
    startDate: '',
  };

  categoryPhotoList = [];

  columns = [
    {
      title: '商品类目',
      dataIndex: 'cate_name',
      key: 'cate_name',
      align: 'center',
      width: 100,
    },
    {
      title: '图片分类',
      dataIndex: 'photo_type_name',
      key: 'photo_type_name',
      align: 'center',
      width: 100,
    },
    {
      title: '图片名称',
      dataIndex: 'photo_name',
      key: 'photo_name',
      align: 'center',
      width: 100,
    },
    {
      title: '图片',
      dataIndex: 'url',
      key: 'url',
      align: 'center',
      width: 160,
      scopedSlots: { customRender: 'url' },
    },
    {
      title: '是否默认图片',
      dataIndex: 'is_default',
      key: 'is_default',
      align: 'center',
      width: 160,
      scopedSlots: { customRender: 'is_default' },
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      align: 'center',
      width: 80,
      scopedSlots: { customRender: 'status' },
    },
    {
      title: '创建时间',
      dataIndex: 'created_at',
      key: 'created_at',
      align: 'center',
      width: 120,
    },
    {
      title: '创建人',
      dataIndex: 'operator_name',
      key: 'operator_name',
      align: 'center',
      width: 100,
    },
    {
      title: '操作',
      dataIndex: 'action',
      align: 'center',
      width: 160,
      scopedSlots: { customRender: 'action' },
    },
  ];

  defaultList = [
    {
      label: 1,
      value: '是',
    },
    {
      label: 0,
      value: '否',
    },
  ];
  statusList = [
    {
      label: 1,
      value: '启用',
    },
    {
      label: 0,
      value: '禁用',
    },
  ];

  dataSource = [];

  createDate: any = [];

  @Watch('$route')
  handleSearch() {
    const {
      photoTypeId,
      photoName,
      isDefault,
      status,
      page,
      pageSize,
      endDate,
      startDate,
    } = this.$route.query;
    const { categoryId } = this.$route.params;
    const params: any = {
      page: page || 1,
      pageSize: pageSize || 10,
      cate_id: categoryId,
    };
    if (photoTypeId) {
      params.photo_type_id = photoTypeId;
      this.form.photoTypeId = +photoTypeId;
    }
    if (photoName) {
      params.photo_name = photoName;
      this.form.photoName = photoName;
    }
    if (isDefault) {
      params.is_default = isDefault;
      this.form.isDefault = +isDefault;
    }
    if (status) {
      params.status = status;
      this.form.status = +status;
    }
    if (endDate && startDate) {
      params.end_date = endDate;
      params.start_date = startDate;
      this.createDate = [
        moment(startDate as string),
        moment(endDate as string),
      ];
    }
    this.categoryPhotoAllList(params);
  }

  onChangePage(page: number) {
    this.pagination.current = page;
    this.getQuery();
  }

  onShowSizeChange(current: number, pageSize: number) {
    this.pagination.current = 1;
    this.pagination.pageSize = pageSize;
    this.getQuery();
  }

  onChangePicker(data: any) {
    // console.log(data);
    this.form.startDate = data[0]?.format('YYYY-MM-DD');
    this.form.endDate = data[1]?.format('YYYY-MM-DD');
  }

  getList() {
    // console.log('刷新');
  }

  search() {
    // console.log('搜索');
    this.getQuery();
  }

  reset() {
    // console.log('重置');
    this.form = {
      photoTypeId: undefined,
      photoName: '',
      isDefault: undefined,
      status: undefined,
    };
    this.pagination.current = 1;
    this.createDate = [];
    this.getQuery();
  }

  getQuery() {
    const { photoTypeId, photoName, isDefault, status, startDate, endDate } =
      this.form;
    const { current, pageSize } = this.pagination;

    const query: any = {
      page: current,
      pageSize,
      timestamp: Math.round(Date.now() / 1000),
    };

    if (photoTypeId) {
      query.photoTypeId = photoTypeId;
    }
    if (photoName) {
      query.photoName = photoName;
    }
    if (isDefault) {
      query.isDefault = isDefault;
    }
    if (status !== undefined && status !== null) {
      query.status = status;
    }
    if (startDate && endDate) {
      query.startDate = startDate;
      query.endDate = endDate;
    }

    this.$router.push({
      query,
    });
  }

  mounted() {
    this.getPhotoList();
    this.handleSearch();
  }

  editImg(item: any) {
    this.productImageModal.init(item);
  }

  editStatus(item: any) {
    console.log(item);

    this.$confirm({
      title: '提示',
      content: `确定要${item.status ? '禁用' : '启用'}该分类吗？`,
      onOk: async () => {
        const { cate_id, photo_type_id, photo_id } = item;
        const data = {
          cate_id,
          photo_type_id,
          photo_id,
          status: item.status === 1 ? 0 : 1,
        };
        const res = await this.spuService.postCategoryPhotoEditPhoto(data);
        if (res) {
          this.$message.success('操作成功');
          this.handleSearch();
        }
        return true;
      },
      onCancel() {},
    });
  }

  editDefault(item: any) {
    // console.log(item);
    this.$confirm({
      title: '提示',
      content: `确定要${item.is_default ? '取消' : '设置'}为默认吗？`,
      onOk: async () => {
        const { cate_id, photo_type_id, photo_id } = item;
        const data = {
          cate_id,
          photo_type_id,
          photo_id,
          is_default: item.is_default === 1 ? 0 : 1,
        };
        const res = await this.spuService.postCategoryPhotoEditPhoto(data);
        if (res) {
          this.$message.success('操作成功');
          this.handleSearch();
        }
        return true;
      },
      onCancel() {},
    });
  }
  editDelete(item: any) {
    this.$confirm({
      title: '提示',
      content: '确定要删除该图片吗？',
      onOk: async () => {
        const { cate_id, photo_type_id, photo_id } = item;
        const data = {
          cate_id,
          photo_type_id,
          photo_id,
          is_del: 1,
        };
        const res = await this.spuService.postCategoryPhotoEditPhoto(data);
        if (res) {
          this.$message.success('操作成功');
          this.handleSearch();
        }
        return true;
      },
      onCancel() {},
    });
  }

  async categoryPhotoAllList(params: any) {
    const res = await this.spuService.postSpuCategoryPhotoAllList(params);

    this.dataSource = res.list;
    this.pagination.total = res.total;
    // console.log(res);
  }

  async getPhotoList() {
    const { categoryId } = this.$route.params;
    const res = await this.spuService.getSpuCategoryPhotoList({
      cate_id: categoryId,
      page_size: 50,
    });
    this.categoryPhotoList = res.list;
  }

  addImage() {
    this.uploadImageModal.init();
  }
}
